<template>
  <div :class="$style.container">
    <div :class="[$style.item, $style.apartments]">
      <elsa-v-select
        :options="apartmentsTypes"
        v-model="selectedApartmentsType"
        label="name"
        :reduce="item => item.id"
        :clearable="false"
        :disabled="apartmentsTypes.length < 2"
        htmlLabel="Тип помещения"

      />
    </div>

    <div :class="$style.item">
      <elsa-v-datepicker
        label="Месяц:"
        v-model="selectedMonth"
        view-format="LLLL yyyy"
        :datepicker-props="{minimumView: 'month'}"
        :clearable="false"
      />
    </div>

    <div :class="$style.rest" v-click-outside="onDeactivateRest">

      <div :class="[$style.item, $style.restToggle]">
        <label class="vs-select--label block">&nbsp;</label>
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-chevron-down"
          icon-after
          @click="restFilterActive = !restFilterActive"
        >
          Еще
        </vs-button>

        <app-tag
          color="success"
          :class="$style.badge"
          v-if="activeRestFilters"
          v-text="activeRestFilters"
          key="activeRestFiltersCount"
        />
      </div>

      <div :class="[$style.restFilter, restFilterActive && $style.restFilterActive]">
        <div :class="[$style.item, $style.dateInterval]">
          <elsa-v-datepicker
            :class="$style.date"
            label="Дата акта ПП:"
            v-model="passDateFrom"
          />
          <div :class="$style.dash">-</div>
          <elsa-v-datepicker
            :class="$style.date"
            :label="'\u00A0'"
            v-model="passDateTo"
          />
        </div>

        <div :class="$style.item">
          <label class="vs-select--label mr-2 block mb-2">Показывать архивные</label>
          <vs-switch class="ml-2" v-model="showArchive" />
        </div>

        <div :class="$style.item">
          <label class="vs-select--label mr-2 block mb-2">Только окончательные начисления</label>
          <vs-switch class="ml-2" v-model="showShownOnly" />
        </div>

        <div :class="$style.item">
          <label class="vs-select--label mr-2 block mb-2">Без акта приема</label>
          <vs-switch class="ml-2" v-model="withoutDatePass" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "AccountsFilter",
  props: ['onChange'],
  data() {
    return {
      selectedApartmentsType: null,
      selectedMonth:          new Date(this.$store.getters['appUser/selectedDate']),
      passDateFrom:           null,
      passDateTo:             null,
      showArchive:            localStorage['accounts.showArchive'] === 'true',
      showShownOnly:          localStorage['accounts.showShownOnly'] === 'true',
      withoutDatePass:        localStorage['accounts.withoutDatePass'] === 'true',

      restFilterActive: false,
    };
  },
  computed: {
    apartmentsTypes() {
      return [
        { id: null, name: 'Все' },
        ...this.$store.getters['appUser/availableApartmentsTypes'],
      ];
    },

    activeRestFilters() {
      let total = 0;
      if (this.passDateFrom || this.passDateTo) total++;
      if (this.showArchive) total++;
      if (this.showShownOnly) total++;
      if (this.withoutDatePass) total++;
      return total;
    },
  },
  methods:  {
    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length === 1) {
        this.selectedApartmentsType = this.apartmentsTypes[0].id;
      } else if (this.apartmentsTypes.length > 1) {
        this.selectedApartmentsType = null;
      }
    },

    updateFilter() {
      const { onChange } = this;
      const filter = {
        apartmentsType:  this.selectedApartmentsType,
        month:           this.selectedMonth,
        passDate:        [this.passDateFrom, this.passDateTo],
        showArchive:     this.showArchive,
        showShownOnly:   this.showShownOnly,
        withoutDatePass: this.withoutDatePass,
      };
      onChange && onChange(filter);
    },

    onDeactivateRest() {
      this.restFilterActive = false;
    },
  },
  watch:    {
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },

    selectedApartmentsType() {
      this.updateFilter();
    },

    selectedMonth( value ) {
      this.$store.dispatch('appUser/SET_DATE', value);
      this.updateFilter();
    },

    passDateFrom() {
      this.updateFilter();
    },

    passDateTo() {
      this.updateFilter();
    },

    showArchive( value ) {
      localStorage['accounts.showArchive'] = value;
      this.updateFilter();
    },

    showShownOnly( value ) {
      if (value && this.withoutDatePass) this.withoutDatePass = false;
      localStorage['accounts.showShownOnly'] = value;
      this.updateFilter();
    },

    withoutDatePass( value ) {
      if (value && this.showShownOnly) this.showShownOnly = false;
      localStorage['accounts.withoutDatePass'] = value;
      this.updateFilter();
    },
  },
  mounted() {
    this.updateSelectedApartmentsType();
    this.updateFilter();
  },
};
</script>

<style lang="scss" module>
$breakpoint: 1300px;

.container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  @media screen and (max-width: $breakpoint) {
    flex-wrap: nowrap;
  }
}

.item {
  margin: .5em;
}

.apartments {
  width: 200px;
}

.dateInterval {
  display: flex;
  align-items: flex-start;
}

.date {
  width: 100px;
}

.dash {
  margin: 28px 3px 0;
}

.rest {
  display: contents;
}

.restFilter {
  display: contents;
  @media screen and (max-width: $breakpoint) {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    position: absolute;
    background: #fff;
    right: 0;
    padding: .5em;
    top: 100%;
    width: auto;
    z-index: 1;
    border-radius: 4px;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .1);
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transform: translateY(15px);
    @include anim();
  }
}

.restFilterActive {
  @media screen and (max-width: $breakpoint) {
    pointer-events: all;
    opacity: 1;
    visibility: visible;
    transform: none;
  }
}

.restToggle {
  position: relative;
  display: none;
  @media screen and (max-width: $breakpoint) {
    display: block;
  }
}

.badge {
  position: absolute;
  background: #000;
  top: 9px;
  right: -12px;
}

</style>
